import {
  blueGrey,
  deepPurple,
  green,
  grey,
  indigo,
  lightGreen,
  orange,
  red,
} from '@mui/material/colors'
import { type Color, type CommonColors } from '@mui/material/styles'

const common: CommonColors = {
  black: '#000',
  white: '#fff',
}

const brandBlack: Color = {
  50: '#e6f0ef',
  100: '#b3d1ce',
  200: '#80b1ad',
  300: '#4d918c',
  400: '#26776f',
  500: '#011514',
  600: '#011210',
  700: '#010f0d',
  800: '#010b0a',
  900: '#000706',
  A100: '#4d8c84',
  A200: '#26776f',
  A400: '#00564e',
  A700: '#00403a',
}

const brandGreen: Color = {
  50: '#ebfceb',
  100: '#cef6cd',
  200: '#acf0ac',
  300: '#87e989',
  400: '#64e26c',
  500: '#3bdc51',
  600: '#25cb48',
  700: '#00b63d',
  800: '#00a133',
  900: '#007d1f',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#3bdc51',
  A700: '#23c338',
}

export const colors = {
  common,
  brandBlack,
  brandGreen,
  grey,
  blueGrey,
  lightGreen,
  green,
  orange,
  red,
  deepPurple,
  indigo,
}
